// extracted by mini-css-extract-plugin
export default {"wrapperClass":"n7SvLwerq4JAUA30sATZ"};